// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

import type { EmailIpWarmingAppGroupIdScheduleSettingsResult } from "./types";

const isIpWarmingSetting = objectOf({
  c_id: string,
  ag_id: string,
  start_date: string,
  current_volume: number,
  target_volume: number,
  days_of_week: arrayOf(number),
  user_segment_ids: maybe(arrayOf(string)),
  email_template_ids: maybe(arrayOf(string)),
  from_email_address: maybe(string),
  send_hours_start: maybe(string),
  send_hours_end: maybe(string),
  mailbox_providers_to_throttle: maybe(arrayOf(string)),
});

export const isEmailIpWarmingAppGroupIdScheduleSettingsResult =
  objectOf<EmailIpWarmingAppGroupIdScheduleSettingsResult>({
    ip_warming_setting: isIpWarmingSetting,
  });
